import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-plus',
  templateUrl: './icon-account-plus.component.html',
  styleUrl: './icon-account-plus.component.scss',
  standalone: false,
})
export class IconAccountPlusComponent {
  @Input() tooltip?: string;
}
